import { Cliente } from '../../pessoa/cliente/cliente';
import { Representante } from '../../pessoa/representante/representante';

/** Utilizada para baixar um cliente */
export class ClienteCarteiraBaixar {
    idCliente: number;
    cliente: Cliente;
    representante: Representante;
    dataBaixa: Date;
    baixaManual: boolean;
    nomeUsuarioBaixa: string;
    motivoBaixa: string;
}
